import Image from "next/image";
import React from "react";

type bgHeaderNewProps = {
  jobData: jobDescriptionType;
  mediaUrl: string;
};

const JobHeaderBg: React.FC<bgHeaderNewProps> = ({ jobData, mediaUrl }) => {
  const {
    hideCompanyName,
    companyName = "",
    companyLogoUrl = "",
    isGptwCompany,
  } = jobData;

  const logoSrc =
    !hideCompanyName && companyLogoUrl
      ? companyLogoUrl
      : companyName === "Confidential" || (!companyName && hideCompanyName)
        ? `https://${mediaUrl}/public/core/images/companyLogoConfidential.png`
        : `https://${mediaUrl}/public/core/images/companyLogoDefault.png`;

  const logoAlt = companyName || "Confidential";

  return (
    <div className="bg-jdPage-gradient relative flex min-h-[94px] px-6 py-4 md:!rounded-t-2xl">
      <div className="border-surface-primary-disabled bg-surface-primary-normal absolute left-4 top-[45px] flex size-[70px] items-center justify-center rounded border border-solid p-px md:!left-[30px] md:!top-[50px]">
        {/* <Image src={logoSrc} alt={logoAlt} height={56} width={56} /> */}
        <img src={logoSrc} alt={logoAlt} />
      </div>
      {!!isGptwCompany && (
        <div className="absolute right-6 top-0 h-[63px] w-[36px]">
          {/* <Image
            src={`https://${mediaUrl}/public/core/images/gptw.png`}
            alt="certified job"
            layout="fill"
            objectFit="contain"
          /> */}
          <img
            src={`https://${mediaUrl}/public/core/images/gptw.png`}
            alt="certified job"
          />
        </div>
      )}
    </div>
  );
};

export default JobHeaderBg;
